import { render, staticRenderFns } from "./WaveExperience.vue?vue&type=template&id=5681e318&"
import script from "./WaveExperience.vue?vue&type=script&lang=js&"
export * from "./WaveExperience.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports